import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-98">
      {label && <label htmlFor={inputId} className="block text-sm font-bold text-brand-dark mb-1" data-id="element-99">
          {label}
        </label>}
      <input id={inputId} className={`w-full px-4 py-2 border-2 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:border-transparent transition-all
          ${error ? 'border-red-500' : 'border-gray-300'}
          ${className}`} {...props} data-id="element-100" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-101">{error}</p>}
    </div>;
}